import React from "react";
import { QuestionStep, QuestionStepProps } from "./QuestionStep";
import { URLInput, validateURL } from "@xapp/components";

export type WebsiteQuestionStepProps = Omit<
    QuestionStepProps<string>,
    "title" | "hasValueLabel" | "noValueLabel" | "valueLabel"
>;

export const WebsiteQuestionStep = (
    props: Omit<
        QuestionStepProps<string>,
        "title" | "hasValueLabel" | "noValueLabel" | "valueLabel" | "renderInput" | "canClickNext"
    >
) => {
    return (
        <QuestionStep<string>
            title="Do you have a website?"
            description="If you have a website, we can use its content to help train your AI, accelerate onboarding, and help you install widgets."
            hasValueLabel="I have a website (recommended)"
            hasValueDescription="Great! We can use its content to help train your AI, accelerate onboarding, and you can booking and chat directly on your website."
            noValueLabel="I don't have a website"
            noValueDescription="No problem! You can always add a website later. For now, we will use the default settings."
            initialValue={props.initialValue || ""}
            renderInput={(value, setValue, disabled) => (
                <URLInput
                    label="Business Website"
                    onChange={(val: string, valid: boolean) => {
                        setValue(val);
                    }}
                    disabled={disabled}
                    value={value}
                />
            )}
            canClickNext={(hasValue, value) => {
                if (hasValue) {
                    return !!value && validateURL(value).valid;
                }
                return typeof hasValue === "boolean" ? !hasValue : false;
            }}
            {...props}
        />
    );
};
